import { expValEquals, isExperimentEnabled } from '@confluence/feature-experiments';

export function getHasAudioButton({
	isAIEnabledForContent,
	isAIEarlyAccessEnabled,
}: {
	isAIEnabledForContent: boolean;
	isAIEarlyAccessEnabled: boolean;
}): boolean {
	return (
		isAIEnabledForContent &&
		(!isExperimentEnabled('confluence_audio_labs_lozenge') || isAIEarlyAccessEnabled) &&
		(!isExperimentEnabled('confluence_audio_v3') ||
			expValEquals('confluence_ai_consumption_byline', 'variant', 'control'))
	);
}
